import type { ReactNode } from 'react';
import { Icon } from './icon';

/** Help text below a field or group, referenced by `aria-describedby`. */
export function FieldDescription({ id, children }: { id?: string; children: ReactNode }) {
  return (
    <p id={id} className="text-xs text-fg-muted">
      {children}
    </p>
  );
}

/** Error below a field or group, in words and with an icon, never colour only. */
export function FieldError({ id, children }: { id?: string; children: ReactNode }) {
  return (
    <p id={id} className="flex items-start gap-1.5 text-xs font-medium text-danger">
      <Icon name="circle-alert" className="mt-px size-3.5" />
      <span>{children}</span>
    </p>
  );
}
